
import { WrapIconMob, IconSearchStyled, WrapSearchMob } from "../menu-search/style";

export const MenuSearchMob = () => {
  return (
    <WrapSearchMob href="/pesquisa">
      <WrapIconMob>
        <IconSearchStyled />
        Pesquisar
      </WrapIconMob>
    </WrapSearchMob>
  );
};
